// Shared so Message and ConversationViewer's inlined event branch can't drift.
export const isMessageDimmed = (
  highlightedMessages: number[] | null | undefined,
  index: number,
  isSelected: boolean,
): boolean => {
  if (highlightedMessages == null || highlightedMessages.length === 0) {
    return false
  }

  return !highlightedMessages.includes(index) && !isSelected
}
